import React from "react"

import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import MarketoForm from "./MarketoForm"
import ContentWidth from "./ContentWidth"

const SplitForm = ({ content }) => {
  return (
    <ContentWidth>
      <Wrapper>
        <ContentDiv>
          <Header dangerouslySetInnerHTML={{ __html: content.header }} />
          <Body dangerouslySetInnerHTML={{ __html: content.body }} />
        </ContentDiv>
        <MarketoForm id={content.formId} />
      </Wrapper>
    </ContentWidth>
  )
}

export default SplitForm

const Body = styled.p`
  ${text.bodyMd};

  h5 {
    ${text.bodyLg};
    margin: 1.389vw 0;

    ${media.fullWidth} {
      margin: 20px 0;
    }

    ${media.tablet} {
      margin: 1.953vw 0;
    }

    ${media.mobile} {
      margin: 4.673vw 0;
    }
  }
`
const Header = styled.h3`
  ${text.h3};
`
const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 35.694vw;

  ${media.fullWidth} {
    width: 514px;
  }

  ${media.tablet} {
    width: 41.113vw;
  }

  ${media.mobile} {
    width: 87.85vw;
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0 10.278vw;
  gap: 4.583vw;

  ${media.fullWidth} {
    padding: 0 148px;
    gap: 66px;
  }

  ${media.tablet} {
    padding: 0 3.906vw;
    gap: 5.859vw;
  }

  ${media.mobile} {
    flex-direction: column;
    padding: 0 6.075vw;
    gap: 9.346vw;
  }
`
